import { CLOUD_PACKAGE_VERSION } from '../../version'

export const CLIENT_VERSION_HEADER = 'X-Qodana-Client-Version'

export function prepareClientVersionHeaders(headers: Headers): Headers {
	headers.set(CLIENT_VERSION_HEADER, CLOUD_PACKAGE_VERSION)
	return headers
}
